import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useUser } from '../../context/UserContext';

/**
 * Garde les routes protégées : tant que /auth/me n'a pas répondu, on affiche
 * un loader minimal ; si non connecté, redirection vers /login.
 *
 * Idéalement on conserverait l'URL de destination pour rebondir après login.
 * Comme le callback OAuth redirige par défaut vers '/', on ne le fait pas
 * encore — à ajouter quand utile.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user } = useUser();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Chargement…
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
